<div *ngIf="visible" [style]="containerStyles">
    <app-text *ngIf="text" [color]="getTextColor" [style]="textStyles" variant="headingXLarge">{{text}}</app-text>
    <div [style]="loadingContainerStyle">
      <app-loading-dot [circleSize]="circleSize" [color]="loadingDotColor"></app-loading-dot>
    </div>
</div>
